import React from 'react';
import withIcon from '../utilities/withIcon';

const IconWrench = () => {
  return (
    <g>
      <path d="M13.372.514a.756.756 0 0 1 .26 1.132l-.066.076-2.352 2.35.713.713 2.351-2.35a.756.756 0 0 1 1.209.194 4.787 4.787 0 0 1-5.651 6.74l-3.797 3.798a3.022 3.022 0 1 1-3.206-3.206L6.63 6.164a4.787 4.787 0 0 1 6.741-5.65zM4.091 11.909a1.511 1.511 0 1 0-2.137 2.137A1.511 1.511 0 0 0 4.09 11.91zm4.316-3.247a4.82 4.82 0 0 1-1.069-1.069l-2.78 2.78a3.028 3.028 0 0 1 1.068 1.07l2.78-2.781zm3.209-7.128-.18-.015A3.274 3.274 0 1 0 14.49 4.76l-.007-.197-.018-.178-2.003 2.003a.756.756 0 0 1-.908.122l-.083-.055-.078-.067-1.78-1.781a.756.756 0 0 1-.068-.992l.068-.077 2.004-2.005z" />
    </g>
  );
};

export default withIcon(IconWrench);
